import { QueryKey } from '../hooks/types'

export function allQueryFilterKeys(): QueryKey[] {
  return [
    'userId',
    'source',
    'userRating',
    'adminRating',
    'customerRating',
    'toTimestamp',
    'fromTimestamp',
    'searchFilter'
  ]
}
